import React, { useEffect, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import DataTable from "react-data-table-component";
import {
  GetContactUsDetails,
  GetContactUsDetailsData,
} from "../../redux/auth-reducer/auth-service";
import dayjs from "dayjs";
import { Button, Col, Row } from "react-bootstrap";
import * as icons from "react-bootstrap-icons";

export const Query = () => {
  const [data, setData] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [dataListItem, setDataListItem] = useState([]);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  function sidebarfun() {
    setData(!data);
  }

  useEffect(() => {
    const GetDataQuries = async () => {
      await GetContactUsDetails().then((res) => {
        setDataListItem(res?.data?.data?.dataList);
      });
    };
    GetDataQuries();
  }, []);

  const GetDataQuries = async (data) => {
    try {
      const response = await GetContactUsDetailsData(data); // Call your API function
      if (response?.data) {
        setDataListItem(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    GetDataQuries(data); // Fetch data when currentPage changes
  }, [currentPage]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    GetDataQuries(data);
    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };
  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }
  const columns = [
    {
      name: "ID",
      selector: (row, index) => index + 1,
    },

    {
      name: "First Name",
      selector: (row) => row?.firstName,
      sortable: true,
    },
    {
      name: "Last Name",
      selector: (row) => row?.lastName,
      sortable: true,
    },

    {
      name: "Message",
      selector: (row) => row?.message || "",
      sortable: true,
      cell: (row) => <p className="message-query">{row?.message}</p>,
    },
    {
      name: "Date & Time",
      selector: (row) => {
        if (!row?.createDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.createDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
      sortable: true,
    },
  ];

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const filteredData = searchText
    ? dataListItem?.filter((item) => {
        return (
          item?.firstName?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.lastName?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.emailId?.toLowerCase().includes(searchText?.toLowerCase())
        );
      })
    : dataListItem;
  const clearSearch = () => {
    setSearchText("");
  };
  return (
    <div className="dasboard-group">
      <TopNavbar sidebarfun={sidebarfun} />
      <Sidebar data={data} />
      <div
        className={
          data ? "dashboard-content full-contnet" : "dashboard-content"
        }
      >
        <h1 className="heading-dash">Queries List</h1>
        <div className="group_data_table">
          <div className="table-transaction">
            <h1 className="subscription_heading ms-4 quries">Queries List</h1>
            <div className="search-input filter d-flex align-items-center">
              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>
            {/* <DataTable

              columns={columns}
              data={filteredData}
              pagination
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10, 15, 20]}
              paginationTotalRows={filteredData?.length}
            /> */}

            <div>
              <DataTable
                // title="Sport List"
                columns={columns}
                data={filteredData}
                paginationPerPage={perPage}
                paginationTotalRows={totalRows * 10}
                paginationDefaultPage={currentPage}
                onChangePage={setCurrentPage}
              />
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <>
                        <label>Rows per page: </label>{" "}
                        <select
                          id="itemsPerPage"
                          value={perPage}
                          onChange={handlePerPageChange}
                        >
                          {pageOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {currentPage} of {totalRows}{" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={data ? "footer" : "footer-content"}>
        <Footer />
      </div>
    </div>
  );
};
